import React from "react";
import { useAuth } from "../../hooks/useAuth";
import { Box, Typography } from "@mui/material";
import { firstandLastName } from "../../utils/url-id";

const AvatarImage = ({
  height,
  width,
  name,
}: {
  height: number;
  width: number;
  name: string;
  
}) => {
  // Get initials
  const getInitials = () => {
    const firstInitial = name ? name.charAt(0) : "";
    const lastInitial = name ? name.charAt(1) : "";
    return (firstInitial + lastInitial).toUpperCase();
  };
  // Generate a consistent color based on the user's name
  const getBackgroundColor = () => {
    const colors = ["#6881C8", "#3E3E3B7D", "#B8B8B8", "#BDBDBD", "#3E3873"];

  };

  return (
    <Box
      sx={{
        backgroundColor: "#6881C8",
        height: height,
        width: width,
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          fontSize: 18,
          fontWeight: "bold",
          textTransform: "uppercase",
          lineHeight: 1,
          letterSpacing: 0.5,
          color: "white",
        }}
      >
        {firstandLastName(name) ?? "MM"}
      </Typography>
    </Box>
  );
};

export default AvatarImage;
